import _isProperty from "is-property";
var exports = {};
var isProperty = _isProperty;

var gen = function (obj, prop) {
  return isProperty(prop) ? obj + "." + prop : obj + "[" + JSON.stringify(prop) + "]";
};

gen.valid = isProperty;

gen.property = function (prop) {
  return isProperty(prop) ? prop : JSON.stringify(prop);
};

exports = gen;
export default exports;